module.exports = __webpack_public_path__ + "3310479257a85e7d1976dbf812aa41c8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/wise-owls.png
// module id = 539
// module chunks = 0